// Returns complete sizing string with inches.
export default function formatSize(cm: number): string {
  return `${cm}cm/${toInches(cm)}"`;
}
// Converts cm-value to inches and rounds to one decimal-point.
function toInches(cm: number) {
  return (cm * 0.3937).toFixed(1);
}
